import {Component, inject} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {LocalStorageService} from "../../services/local-storage.service";
import {DOCUMENT} from "@angular/common";
import {AnalyticsService} from "../../services/analytics.service";
import {setCookie} from '../../../utils/helper';
import {MatAnchor, MatButton} from '@angular/material/button';

declare const gtag: Function;

@Component({
  selector: 'app-cookie',
  imports: [
    MatButton
  ],
  templateUrl: './cookie.component.html',
  styleUrl: './cookie.component.scss'
})
export class CookieComponent {

  readonly document = inject(DOCUMENT);

  constructor(
    public dialog: MatDialog,
    private localStorage: LocalStorageService,
    private analyticsService: AnalyticsService,
  ) {
  }

  public closeModal() {
    const modal = this.document.getElementsByClassName('cookie-modal');
    // this.renderer.addClass(modal[0], 'animate-fade-out');
    setTimeout(() => {
      this.dialog.closeAll();
    }, 500)
  }

  public accept() {
    this.analyticsService.initialize();
    setTimeout(() => {
      this.localStorage.setItem('selective-bits-cookie', 'true');
      setCookie('ad_storage', 'granted', 365);
      setCookie('ad_user_data', 'granted', 365);
      setCookie('ad_personalization', 'granted', 365);
      setCookie('analytics_storage', 'granted', 365);
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted',
        'ad_user_data': 'granted',
      })
      this.closeModal();
    })
  }

  public decline() {
    this.closeModal();
  }
}
